$(document).ready(function () {
  // $('#buscadorWords').attr('bootstrap', '1');
  //Busqueda predictiva
  function buscadorNavXsOpen() {
    $('#buscadorXs').slideToggle('slow',
      function() { window.location = '#buscadorXs'; });
    $('#buscadorXsButton').hide();
  }

  function buscadorNavXsClose() {
    $('#buscadorXs').slideToggle('slow');
    $('#buscadorXsButton').show();
  }


});
